<section class="faq" id="faq">
  <div class="faq--container">
    <!-- Header Section -->
    <div class="faq--header">
      <h2 class="faq--title">Frequently Asked Questions</h2>
      <p class="faq--description">
        Get insights into how MahaAgX powers the agricultural ecosystem. Discover how our secure data exchange and AI Sandbox facilitate the development of high-impact agri-tech Use Cases tailored for Maharashtra’s diverse farming landscape.</p>
    </div>

    <!-- FAQ Items -->
    <div class="faq--list">
      <div
        *ngFor="let faq of filteredFaqs"
        class="faq--item"
        [class.expanded]="faq.isExpanded"
      >
        <button
          class="faq--question"
          (click)="toggleFaq(faq.id)"
          [attr.aria-expanded]="faq.isExpanded"
        >
          <span class="question--number">{{ faq.id }}</span>
          <span class="question--text">{{ faq.question }}</span>
          <span class="question--icon">
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
              <line *ngIf="!faq.isExpanded" x1="12" y1="5" x2="12" y2="19"></line>
              <line x1="5" y1="12" x2="19" y2="12"></line>
            </svg>
          </span>
        </button>
        
        <div class="faq--answer" *ngIf="faq.isExpanded">
          <p>{{ faq.answer }}</p>
        </div>
      </div>
    </div>
  </div>
</section>



